var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.isGrey===1?'filter':'',attrs:{"id":"app"}},[_c('Denglong',{attrs:{"show":_vm.isYear}}),_c('Header',{attrs:{"user-info":_vm.userInfo}}),_c('SideNavBar'),_c('Loading'),_c('router-view',{key:_vm.$route.fullPath,staticStyle:{"min-height":"100vh"}}),_c('LoginModle'),_c('SearchModle'),_c('Sidebar'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }